export default __webpack_public_path__ + "static/media/020_start.av1.1235c75b.mp4";